
export let baseURL = process.env.VUE_APP_BASE_URL;
export let baseURLv2 = process.env.VUE_APP_BASE_URL;
export let baseURLBetaG1G = process.env.VUE_APP_BASE_URL;

//export let baseURL = `https://g1g-backend.test/api/v1`;
